// The full-stack API and frontend share the configured origin. Keep staff on
// that origin before mounting auth: cross-site cookie logins fail on aliases.
export const canonicalAppUrl = (currentHref, backendUrl) => {
  const current = new URL(currentHref);
  // Нативное приложение (Capacitor) работает со схем capacitor:///ionic://,
  // и его нельзя «канонизировать» на веб-origin — иначе iOS-приложение
  // выбросило бы клиента на сайт.
  if (!["https:", "http:"].includes(current.protocol)) return null;
  // Android-оболочка отдаёт локальные ассеты по https://localhost — это тоже
  // приложение, а не алиас сайта. Без этой проверки Android-сборка сама
  // уходила на app.angiolini.kz: мост Capacitor там недоступен (androidBridge
  // выдаётся только для разрешённых origin), поэтому push превращались в
  // «устройство не поддерживает», а оформление бралось с сайта.
  if (["localhost", "127.0.0.1", "[::1]"].includes(current.hostname)) return null;
  const configured = new URL(backendUrl);
  if (!["https:", "http:"].includes(configured.protocol) || configured.username || configured.password) {
    throw new Error("Invalid application origin configuration");
  }
  if (current.origin === configured.origin) return null;
  const target = new URL(configured.origin);
  target.pathname = current.pathname;
  target.search = current.search;
  target.hash = current.hash;
  return target.href;
};